import { endpoints } from '../api/sharedEndpoints';
import type { AuthTelegramResponse, EventsListResponse, GroupsListResponse, UsersListResponse } from '../api/types';

export interface BootstrapRepository {
  authTelegram(initData: string): Promise<AuthTelegramResponse>;
  getMe(): Promise<AuthTelegramResponse>;
  listEventsRange(params: { from: string; to: string }): Promise<EventsListResponse>;
  listGroups(): Promise<GroupsListResponse>;
  listUsers(): Promise<UsersListResponse>;
}

export class ApiBootstrapRepository implements BootstrapRepository {
  async authTelegram(initData: string): Promise<AuthTelegramResponse> {
    return endpoints.authTelegram(initData);
  }

  async getMe(): Promise<AuthTelegramResponse> {
    return endpoints.getMe();
  }

  async listEventsRange(params: { from: string; to: string }): Promise<EventsListResponse> {
    return endpoints.listEventsRange(params.from, params.to);
  }

  async listGroups(): Promise<GroupsListResponse> {
    return endpoints.listGroups();
  }

  async listUsers(): Promise<UsersListResponse> {
    return endpoints.listUsers();
  }
}
